import { render } from "./PFloatLabel.vue?vue&type=template&id=ad2f8ee8"
import script from "./PFloatLabel.vue?vue&type=script&lang=js"
export * from "./PFloatLabel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__